import { defineMessages } from 'react-intl';

export const i18n: {
	label: { id: string; defaultMessage: string; description: string };
	selectedHeadingRequired: { id: string; defaultMessage: string; description: string };
	selectedHeadingMax: { id: string; defaultMessage: string; description: string };
	selectedHeadingPlain: { id: string; defaultMessage: string; description: string };
	currentSiteLabel: { id: string; defaultMessage: string; description: string };
} = defineMessages({
	label: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.label',
		defaultMessage: 'Sites',
		description:
			'Fallback label for the site scope selector shown in the full page search filter bar, allowing users to choose which sites to search.',
	},
	selectedHeadingRequired: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingRequired',
		defaultMessage: 'Selected <hint>(1 required)</hint>',
		description:
			'Heading for the group of selected sites when only the required current site is selected. Communicates that at least one site must remain selected.',
	},
	selectedHeadingMax: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingMax',
		defaultMessage: 'Selected <hint>(Select up to {max})</hint>',
		description:
			'Heading for the group of selected sites, shown when more than the current site is selected and there are enough sites to reach the maximum. {max} is the maximum number of sites that can be selected.',
	},
	selectedHeadingPlain: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingPlain',
		defaultMessage: 'Selected',
		description: 'Heading for the group of selected sites in the site selector dropdown.',
	},
	currentSiteLabel: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.currentSiteLabel',
		defaultMessage: '{name} (current)',
		description:
			'Label for the current/primary site in the site selector. The current site is always selected and cannot be removed. {name} is the site name.',
	},
});
